import Ceo from '../pages/Ceo/Index'

export default [
  {
    path: '/Ceo',
    component: () => import('@/pages/Ceo/Template.vue'),
    children: [
      {
        path: '/Ceo',
        component: Ceo,
      },
    ],
  },
]
